import { customCreateEnum } from './enumArray'

const goldTagClassName =
  'text-[#E29836] bg-[#FDF5E9] px-[2px] border-[1px] border-[#E29836] border-solid rounded'
const greenTagClassName =
  'text-[#069D18] bg-[#E0F5D7] w-[84px] flex justify-center border-[1px] border-[#069D18] border-solid rounded'

const grayTagClassName =
  'text-[#777777] bg-[#DDDDDD] w-[84px] flex justify-center border-[1px] border-[#777777] border-solid rounded'
const redTagClassName =
  'text-[#CD3A15] bg-[#FBDEDE] w-[84px] flex justify-center border-[1px] border-[#CD3A15] border-solid rounded'

export const textGoldClassname = 'text-[#F7AD19]'
export const textGreenClassname = 'text-[#069D18]'
export const textRedClassname = 'text-[#ff4d4f]'
const supplierInquiryStatusList = [
  {
    label: '待接单',
    value: 'WAITING_ORDER',
    numValue: '0',
    tagClassName: goldTagClassName,
  },
  {
    label: '待报价',
    value: 'WAITING_QUOTE',
    numValue: '1',
    tagClassName: goldTagClassName,
  },
  {
    label: '已报价',
    value: 'QUOTED',
    numValue: '2',
    tagClassName: greenTagClassName,
  },
  {
    label: '待重新报价',
    value: 'WAITING_REQUOTE',
    numValue: '3',
    tagClassName: goldTagClassName,
  },
  {
    label: '采购方取消',
    value: 'CANCELLED',
    numValue: '4',
    tagClassName: grayTagClassName,
  },
  {
    label: '供方放弃报价',
    value: 'SUPPLIER_ABANDONED',
    numValue: '5',
    tagClassName: redTagClassName,
  },
] as const

export const supplierInquiryStatusEnum = customCreateEnum(
  supplierInquiryStatusList,
)
const supplierInquiryItemStatusList = [
  {
    label: '已报价',
    value: 'QUOTED',
    className: textGreenClassname,
  },
  {
    label: '待报价',
    value: 'DRAFT',
    className: textGoldClassname,
  },
  {
    label: '已放弃',
    value: 'ABANDONED',
    className: textRedClassname,
  },
  {
    label: '无需报价',
    value: 'NOT_QUOTED',
    className: textRedClassname,
  },
] as const

export const supplierInquiryItemStatusEnum = customCreateEnum(
  supplierInquiryItemStatusList,
)

// 货期
const deliveryPeriodList = [
  {
    label: '当天发货',
    value: '当天发货',
  },
  {
    label: '3天内',
    value: '3天内',
  },
  {
    label: '7天内',
    value: '7天内',
  },
  {
    label: '10天内',
    value: '10天内',
  },
  {
    label: '15天内',
    value: '15天内',
  },
  {
    label: '30天内',
    value: '30天内',
  },
  {
    label: '45天内',
    value: '45天内',
  },
  {
    label: '60天及以上',
    value: '60天及以上',
  },
]
export const deliveryPeriodEnum = customCreateEnum(deliveryPeriodList)

/**
 * 状态（供应商响应状态）
 * 0 :待接单：供应商在SCP接单
 * 1 :待报价：供应商在SCP对待接单的询价单直接报价
 * 2 :已报价：供应商在SCP对待报价的询价单进行报价
 * 3 :待重新报价：采购在SRM重新报价，供应商在SCP重新报价
 * 4 :采购方取消：采购在SRM放弃询价或采购在SRM选用了其他报价
 */
import { customCreateEnum } from './enumArray'

const goldTagClassName =
  'text-[#E29836] bg-[#FDF5E9] px-[2px] border-[1px] border-[#E29836] border-solid rounded'
const greenTagClassName =
  'text-[#069D18] bg-[#E0F5D7] w-[84px] flex justify-center border-[1px] border-[#069D18] border-solid rounded'

const grayTagClassName =
  'text-[#777777] bg-[#DDDDDD] w-[84px] flex justify-center border-[1px] border-[#777777] border-solid rounded'
const redTagClassName =
  'text-[#CD3A15] bg-[#FBDEDE] w-[84px] flex justify-center border-[1px] border-[#CD3A15] border-solid rounded'

export const textGoldClassname = 'text-[#F7AD19]'
export const textGreenClassname = 'text-[#069D18]'
export const textRedClassname = 'text-[#ff4d4f]'
const supplierInquiryStatusList = [
  {
    label: '待接单',
    value: 'WAITING_ORDER',
    numValue: '0',
    tagClassName: goldTagClassName,
  },
  {
    label: '待报价',
    value: 'WAITING_QUOTE',
    numValue: '1',
    tagClassName: goldTagClassName,
  },
  {
    label: '已报价',
    value: 'QUOTED',
    numValue: '2',
    tagClassName: greenTagClassName,
  },
  {
    label: '待重新报价',
    value: 'WAITING_REQUOTE',
    numValue: '3',
    tagClassName: goldTagClassName,
  },
  {
    label: '采购方取消',
    value: 'CANCELLED',
    numValue: '4',
    tagClassName: grayTagClassName,
  },
  {
    label: '供方放弃报价',
    value: 'SUPPLIER_ABANDONED',
    numValue: '5',
    tagClassName: redTagClassName,
  },
] as const

export const supplierInquiryStatusEnum = customCreateEnum(
  supplierInquiryStatusList,
)
const supplierInquiryItemStatusList = [
  {
    label: '已报价',
    value: 'QUOTED',
    className: textGreenClassname,
  },
  {
    label: '待报价',
    value: 'DRAFT',
    className: textGoldClassname,
  },
  {
    label: '已放弃',
    value: 'ABANDONED',
    className: textRedClassname,
  },
  {
    label: '无需报价',
    value: 'NOT_QUOTED',
    className: textRedClassname,
  },
] as const

export const supplierInquiryItemStatusEnum = customCreateEnum(
  supplierInquiryItemStatusList,
)

// 货期
const deliveryPeriodList = [
  {
    label: '当天发货',
    value: '当天发货',
  },
  {
    label: '3天内',
    value: '3天内',
  },
  {
    label: '7天内',
    value: '7天内',
  },
  {
    label: '10天内',
    value: '10天内',
  },
  {
    label: '15天内',
    value: '15天内',
  },
  {
    label: '30天内',
    value: '30天内',
  },
  {
    label: '45天内',
    value: '45天内',
  },
  {
    label: '60天及以上',
    value: '60天及以上',
  },
]
export const deliveryPeriodEnum = customCreateEnum(deliveryPeriodList)

/**
 * 状态（供应商响应状态）
 * 0 :待接单：供应商在SCP接单
 * 1 :待报价：供应商在SCP对待接单的询价单直接报价
 * 2 :已报价：供应商在SCP对待报价的询价单进行报价
 * 3 :待重新报价：采购在SRM重新报价，供应商在SCP重新报价
 * 4 :采购方取消：采购在SRM放弃询价或采购在SRM选用了其他报价
 */
